import { DateTime } from 'luxon';
import * as yup from 'yup';

import { validationMessages } from './validationMessages';

const formatPhoneNumber = (value?: string) => value?.replace(/[^0-9,+]/g, '');

yup.addMethod<yup.StringSchema>(yup.string, 'phone', function () {
  return this.transform((value) => {
    const formattedNumber = formatPhoneNumber(value?.toString());
    return formattedNumber;
  }).min(12, validationMessages.phone.default);
});

yup.addMethod<yup.StringSchema>(yup.string, 'date', function () {
  return this.test('is-date', validationMessages.date.format, (value) => {
    return !!value && DateTime.fromFormat(value, 'yyyy-MM-dd').isValid;
  });
});

yup.addMethod<yup.NumberSchema>(yup.number, 'zip', function () {
  return this.test({
    message: validationMessages.zip.length,
    name: 'isValidLength',
    test: (value) => {
      return !!value && /^\d{5}$/.test(value.toString());
    },
  });
});

yup.addMethod<yup.NumberSchema>(yup.number, 'ssn', function () {
  return this.test({
    message: validationMessages.ssn.length,
    name: 'isValidLength',
    test: (value) => {
      return !!value && /^\d{9}$/.test(value.toString());
    },
  });
});

yup.addMethod<yup.NumberSchema>(yup.number, 'ssnLast4', function () {
  return this.test({
    message: validationMessages.shortSSN.length,
    name: 'isValidLength',
    test: (value) => {
      return !!value && /^\d{4}$/.test(value.toString());
    },
  });
});

yup.addMethod<yup.NumberSchema>(yup.number, 'currencyCents', function () {
  return this.min(1, validationMessages.currency.min);
});

declare module 'yup' {
  interface StringSchema {
    date(): this;
    phone(): this;
  }

  interface NumberSchema {
    currencyCents(): this;
    ssn(): this;
    ssnLast4(): this;
    zip(): this;
  }
}

export { yup };
